import React, {useEffect, useState} from 'react';

import {Spinner} from '#Client/components/Spinner/Spinner';
import {
  getPuzzlesWithWord,
  GetPuzzlesWithWordResponse,
  invalidateWord,
  InvalidateWordResponse,
} from '#Common/api/api';

type Props = {
  word: string;
  onClose: () => void;
};

export const WordAdmin = ({word, onClose}: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [puzzlesWithWordInfo, setPuzzlesWithWordInfo] =
    useState<GetPuzzlesWithWordResponse>();

  const [invalidateResults, setInvalidateResults] = useState<
    InvalidateWordResponse | undefined
  >();

  useEffect(() => {
    (async () => {
      const puzzlesWithWord = await getPuzzlesWithWord(word);
      console.log('puzzlesWithWord: ', puzzlesWithWord);
      // setLeaderboardData(leaderboards);
      if (!puzzlesWithWord.isWordInTodayPuzzles) {
        setIsChecked(false);
      }
      setPuzzlesWithWordInfo(puzzlesWithWord);
      setIsLoading(false);
    })();
  }, []);

  const handleInvalidateClick = async () => {
    setIsLoading(true);
    const response = await invalidateWord(word, isChecked);
    console.log('response: ', response);
    setInvalidateResults(response);
    setIsLoading(false);
  };

  return (
    <div>
      <h2>
        {word}
        <button onClick={onClose}>X</button>
      </h2>
      {isLoading || puzzlesWithWordInfo === undefined ? (
        <div className="textAlignCenter">
          Just a sec. <Spinner />
        </div>
      ) : invalidateResults === undefined ? (
        <div>
          <div>
            Number of puzzles: {puzzlesWithWordInfo.dailyPuzzles.length}
          </div>
          <div>
            Today: {puzzlesWithWordInfo.isWordInTodayPuzzles ? 'Yes' : 'No'}
          </div>
          <input
            checked={isChecked}
            disabled={!puzzlesWithWordInfo.isWordInTodayPuzzles}
            type="checkbox"
            onChange={event => setIsChecked(event.target.checked)}
          />
          Also today
          <button
            disabled={puzzlesWithWordInfo.dailyPuzzles.length === 0}
            onClick={handleInvalidateClick}
          >
            Invalidate Word
          </button>
        </div>
      ) : (
        <div>
          <h3>Marked {invalidateResults.inactivePuzzleIds.length} inactive.</h3>
          <div>{invalidateResults.inactivePuzzleIds.join(', ')}</div>
          <h3>Deleted and replaced</h3>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Difficulty</th>
              </tr>
            </thead>
            <tbody>
              {invalidateResults.replacements.map(
                ({dateString, difficulty}, index) => (
                  <tr key={index}>
                    <td>{dateString}</td>
                    <td>{difficulty}</td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
